import React from 'react'
import Slider from 'react-slick'

import TeamAshley from 'assets/images/team/ashley.webp'
import TeamCasey from 'assets/images/team/casey.webp'
import TeamRahim from 'assets/images/team/rahim.webp'
import TeamMichael from 'assets/images/team/michael.webp'

import TeamMember from 'components/blocks/TeamMember/Top'

import SliderWrap from './styles'

const TeamSlider: React.FC = (): React.ReactElement => (
  <SliderWrap>
    <Slider infinite={true} speed={500} slidesToShow={1} slidesToScroll={1}>
      <TeamMember
        image={TeamMichael}
        name='Michael DeLaGrange'
        title='Founder & CEO'
      />
      <TeamMember
        image={TeamCasey}
        name='Casey Durbin'
        title='Chief Information Officer'
      />
      <TeamMember
        image={TeamAshley}
        name='Ashley DeLaGrange'
        title='Chief Brand Officer'
      />
      <TeamMember
        image={TeamRahim}
        name='Rahim Kanji'
        title='Chief Financial Officer'
      />
    </Slider>
  </SliderWrap>
)

export default TeamSlider
